<template>
    <div id="centreRight1">
        <div class="bg-color-black">
            <div class="d-flex pt-2 pl-2">
                <span style="color:#5cd9e8">
                  <icon name="chart-line"></icon>
                </span>
                <div class="d-flex">
                    <span class="fs-xl text mx-2">数据趋势图</span>
                    <dv-decoration-3 style="width:1.25rem;height:.25rem; position:relative;top:-.0375rem;" />
                </div>
            </div>
            <div>
                <div id="line2" style="width:6rem;height:3rem;margin-top: 10px"></div>
            </div>
<!--            <div v-else>-->
<!--                <div style="margin: 20px">暂无报警设备</div>-->
<!--            </div>-->
        </div>
    </div>
</template>

<script>
  import echartMixins from "@/utils/resizeMixins";
  export default {
    data() {
      return {
        chart: null
      };
    },
    mixins: [echartMixins],
    mounted() {
      this.draw();
    },
    props: {
      line2_data: {
        type: Object
      }
    },
    methods: {
      draw() {
        console.log(this.line2_data)
        // 基于准备好的dom，初始化echarts实例
        this.chart = this.$echarts.init(document.getElementById("line2"));

        let option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          legend: {
            data: ['一氧化碳', '温度'],
            textStyle:{//图例文字的样式
              color:'#5cd9e8',
            }
          },
          // toolbox: {
          //   feature: {
          //     saveAsImage: {}
          //   }
          // },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: this.line2_data.x
            }
          ],
          yAxis: [
            {
              type: 'value',
            }
          ],
          series: this.line2_data.series
        };

        this.chart.setOption(option);
      }
    },
    destroyed() {
      window.onresize = null;
    }
  };
</script>
<style lang="scss">
    #centreRight1 {
        padding: 0.2rem;
        height: 4.125rem;
        min-width: 5.75rem;
        border-radius: 0.0625rem;
        .bg-color-black {
            height: 3.9125rem;
            border-radius: 0.125rem;
        }
        .text {
            color: #c3cbde;
        }
        .chart-box {
            margin-top: 0.2rem;
            width: 2.125rem;
            height: 2.125rem;
            .active-ring-name {
                padding-top: 0.125rem;
            }
        }

    }

</style>
